import { useSelector } from 'react-redux';
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { getOrganizationSponsorsURL, getSponsorLogoClickedURL } from '../../services/api/endpoints';
import { AMAZON_S3_BASE_URL } from '../../services/api/config';
import notSponser from "../../assets/images/sponsers.png"

function ScholarshipFooter() {

  const { organizationId } = useParams();
  const [sponsors, setSponsors] = useState<any | null>(null);
  const auth_token = useSelector((state) => state?.login?.loginDetails?.data?.auth_token);
  const user_login_details = useSelector((state) => state?.login?.loginDetails?.data);
  const organization_id = user_login_details?.user?.usersOrganizations[0]?.organizationId;
  const student_org_id = user_login_details?.user?.studentDetails[0]?.schoolId;
  let counselor_org_id = 0;
  if (organizationId) {
    counselor_org_id = parseInt(organizationId);
  }
  else {
    counselor_org_id = user_login_details?.user?.counselorDetails[0]?.organizationId;
  }

  /*  useEffect(() => {
     // Determine the organization ID based on the user's role
     const organizationId = user_login_details?.user?.usersRoles?.[0]?.role?.title === 'Student' ?
       student_org_id :
       counselor_org_id;
   
     if (organizationId) {
       axios
         .get(`${getOrganizationSponsorsURL(organizationId)}`, {
           headers: {
             'Authorization': `Bearer ${auth_token}`
           }
         })
         .then((response) => {
           setSponsors(response.data.data);

         })
         .catch((error) => {
           console.error('Error fetching sponsor data:', error);
         });
     }
   }, [auth_token, student_org_id, counselor_org_id]); */

  // const prevOrganizationId = useRef(null);
  // const prevAuthToken = useRef(null);

  useEffect(() => {
    // Determine the organization ID based on the user's role
    let organizationIdVar;
    if (organizationId) {
      organizationIdVar = counselor_org_id;
    }
    else {
      organizationIdVar = user_login_details?.user?.usersRoles?.[0]?.role?.title === 'Student'
        ? student_org_id
        : counselor_org_id;
    }

    // if (organizationId && (organizationId !== prevOrganizationId.current || auth_token !== prevAuthToken.current)) {
    axios
      .get(`${getOrganizationSponsorsURL(organizationIdVar)}`, {
        headers: {
          'Authorization': `Bearer ${auth_token}`
        }
      })
      .then((response) => {

        setSponsors(response.data.data || []);
      })
      .catch((error) => {
        console.error('Error fetching sponsor data:', error);
      });


  }, [student_org_id, counselor_org_id]);


  const handleClicked = async (id: number) => {
    try {
      const res = await axios.get(`${getSponsorLogoClickedURL(id)}`, {
        headers: {
          'Authorization': `Bearer ${auth_token}`
        }
      })
      if (res) {

      }
    }
    catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div className='footer'>
      <h3>Sponsored By</h3>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '30px' }}>
        {sponsors ? (
          <>
            {sponsors.length === 0 ? (
              <img src={notSponser} alt="noSponsors" style={{ width: '100px', height: '100px' }} />
            ) : (
              sponsors.map((sponsor) => (

                <div key={sponsor?.id} onClick={() => handleClicked(sponsor.id)} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <a href={sponsor?.url} target="_blank" rel="noopener noreferrer" >
                    <Tooltip title={sponsor?.name}>
                      <img
                        src={`${AMAZON_S3_BASE_URL}${sponsor.sponsorsAttachments[0]?.attachment?.s3Url}`}
                        alt={`Sponsor Logo ${sponsor.id}`}
                        style={{ width: '100px', height: '100px', objectFit: 'cover', backgroundSize: 'cover', backgroundPosition: 'center' }}
                      />
                    </Tooltip>
                  </a>
                  {/* <p style={{ marginTop: '5px', textAlign: 'center' }}>{sponsor.name}</p> */}
                </div>
              ))

            )}     </>)
          :
          (
            <img src={notSponser} alt="noSponsors" style={{ width: '100px', height: '100px' }} />
          )}
      </div>
    </div>
  );
}

export default ScholarshipFooter;
